import { Component, Input, ChangeDetectorRef, OnInit, OnDestroy, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatRadioButton } from '@angular/material/radio';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'app-radio-button-list-item',
  templateUrl: './radio-button-list-item.component.html',
  styleUrls: ['./radio-button-list-item.component.scss'],
  imports: [NgClass, NgStyle, MatRadioButton],
})
export class RadioButtonListItemComponent implements OnInit, OnDestroy {
  private changeDetectorRef = inject(ChangeDetectorRef);

  @Input() disabled: boolean = false;
  @Input() value: any;
  @Input() control: AbstractControl;
  @Input() selected: boolean;
  @Input() transparentBackground: boolean = true;
  @Input() hideIcon: boolean = true;

  subscriptions$: Subscription[] = [];

  ngOnInit() {
    if (this.control) {
      this.subscriptions$.push(
        this.control.valueChanges.subscribe(() => {
          this.changeDetectorRef.detectChanges();
        })
      );
    }
  }

  setRadioButton() {
    if (this.disabled) return;

    this.control?.setValue(this.value);
    this.control?.markAsDirty();
  }

  ngOnDestroy() {
    this.subscriptions$.forEach(s => s.unsubscribe());
  }
}
